module.exports = __webpack_public_path__ + "static/media/sort-up-active.60520815.svg";